import trace from '~/lib/trace';
import {useState, useEffect} from 'react';
import {ImageBackground, View} from 'react-native';
import PropTypes from 'prop-types';

import {apiRoot as publicApiRoot} from '~/api/public/endpoints';
import {dealer as dealerApi} from '~/api/private';

const DealerPersona = ({dealer_id, company_name, fallback, size = 32}) => {
  const height = size;
  const width = size;

  const [image, setImage] = useState(null);
  const [company, setCompany] = useState(company_name);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const retrieve = async () => {
      if (dealer_id) {
        const {result: company} = (await dealerApi.company(dealer_id)) ?? {};
        if (company) {
          const image_url = `https://bahnkick.blob.core.windows.net/company-logos/${company.name?.replaceAll(
            '/',
            ':',
          )}.svg`;
          setImage(image_url);
          setCompany(company.name);
          setLoading(true);
        } else {
          setCompany(null);
          setImage(null);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    retrieve().catch(trace);
  }, [dealer_id]);

  useEffect(() => {
    if (company_name) {
      const image_url = `https://bahnkick.blob.core.windows.net/company-logos/${company_name.replaceAll(
        '/',
        ':',
      )}.svg`;
      setImage(image_url);
    }
  }, [company_name]);

  if (image) {
    return (
      <View
        style={{
          visibility: loading ? 'hidden' : 'visible',
        }}>
        <img
          src={image}
          style={{width, height}}
          alt={company}
          onLoad={() => {
            setLoading(false);
          }}
          onError={() => {
            setImage(null);
            setLoading(false);
          }}
        />
      </View>
    );
  }

  if (loading) {
    return <View style={{width, height}}></View>;
  }

  return (
    fallback ?? (
      <View
        style={[
          {
            borderRadius: 50,
            overflow: 'hidden',
            width,
            height,
          },
        ]}>
        <ImageBackground
          style={{width, height}}
          source={{
            uri: `${publicApiRoot}/dealer/photo/${dealer_id}`,
          }}
        />
      </View>
    )
  );
};

DealerPersona.propTypes = {
  dealer_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  company_name: PropTypes.string,
  fallback: PropTypes.node,
  size: PropTypes.number,
};

export default DealerPersona;
